<template>
	<view class="bill-of-lading-details">
		<view class="bangDanMessage"><text>磅单信息</text></view>
		<view class="timeLine" style="font-size: 16rpx;"><u-text v-for="(item, index) in dayRZ" :key="index" :text="item.taskStatusDes"></u-text></view>
		<view class="utilsBox">
			<view class="utils_chil utils_chilTop">
				<u-button text="签到" type="primary" @click="arriveClick"></u-button>
				<u-button text="入场申请" type="primary" @click="rcsqClick"></u-button>
				<u-button text="放空" type="primary"></u-button>
				<u-button text="呼叫客服" type="primary"></u-button>
			</view>
			<view class="utils_chil"><u-button text="展示提煤单" @click="showCaolPickUpBill" type="primary"></u-button></view>
			<view class="utils_chil"><u-button text="上磅计量" @click="cengZhongClick" type="primary"></u-button></view>
		</view>
	</view>
</template>

<script>
export default {
	onLoad(value) {
		console.log('页面加载', value);
		if (value.orderPlanId && value.yyId) {
			this.orderPlanId = value.orderPlanId;
			this.yyId = value.yyId;
		}
	},
	data() {
		return {
			orderPlanId: null,
			yyId: null,
			dayRZ: []
		};
	},
	onShow() {
		this.init();
	},
	methods: {
		init() {
			this.coalDayPage();
		},
		// 日志查询
		coalDayPage() {
			this.$reqGet('coalDayPage').then(res => {
				if (res.code == 0) {
					this.dayRZ = res.data.records;
				}
			});
		},
		showCaolPickUpBill() {
			uni.navigateTo({
				url: `/pages/driver-page/driver-index/bill-of-lading-details/coal-pick-up-bill/coal-pick-up-bill?orderPlanId=${this.orderPlanId}`
			});
		},
		// 签到
		arriveClick() {
			this.$reqPost('arrive', { id: this.orderPlanId }, 'params').then(res => {
				console.log(res, '签到');
			});
		},
		rcsqClick() {
			uni.navigateTo({
				url: `/pages/driver-page/appointment/appointment?takeCoalId=${this.orderPlanId}&type=入场申请&yyId=${this.yyId}`
			});
		},
		cengZhongClick() {}
		/**
		 * @desc 等待取煤单接口
		 * */
	}
};
</script>

<style lang="scss" scoped>
::v-deep.bill-of-lading-details {
	width: 100%;
	height: 100vh;
	margin: 0 auto;
	display: flex;
	flex-direction: column;

	.bangDanMessage {
		font-size: vww(20);
		font-weight: 500;
		border: vww(1) solid #dddddd;
		border-radius: vww(20);
		margin: vww(20);
		margin-bottom: vww(10);
		flex: 1;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	.timeLine {
		margin: vww(20);
		margin-top: vww(10);
		margin-bottom: vww(10);
		border: vww(1) solid #dddddd;
		border-radius: vww(20);
		flex: 2;
	}
	.utilsBox {
		padding: vww(20);
		flex: 1;
		display: flex;
		flex-direction: column;
		.utils_chil {
			flex: 1;
			display: flex;
			align-items: center;
		}
		.utils_chilTop {
			.u-button {
				margin-right: vww(4);
				&:nth-child(4) {
					margin-right: 0;
				}
			}
		}
	}
}
</style>
